import {formatEventTime} from './formatEventTime.js'
import { currencyFormatter } from './currencyFormatter.js';
import { eventData } from '../helper/EventData.js';
import { donateInlineOrderPrompt } from '../donation/donateInlineOrderPrompt.js';

export function generateEventTable() {
  const eventDetails = document.getElementById('gd__checkout__eventDetails');
  const eventTable = document.getElementById('gd__checkout__eventDetails__table');
  if (!eventTable || !eventDetails) {
    console.error('Event Details element not found.');
    return;
  }

  const data = eventData.get()

  if (data?.error) {
    eventDetails.style.display= 'block'
    eventTable.innerHTML = `
      <h2 style="text-align: center;">Event not found!</h2>
      `;
    return;
  }

  // Die Tabelle erstellen
  let tableHTML = `
    <div id="gd__checkout__heading">
      ${data?.name ? `<h2>${data.name}</h2>` : ''}
      ${data?.location ? `<h3>${data.location}</h3>` : ''}
      ${data?.start_time ? `<span class="start_time">${formatEventTime(data.start_time)}</span>` : ''}
    </div>
    <table style="width: 100%; border-collapse: collapse;">
      <thead class="table--head">
        <tr>
          <th class="first-cell">Item</th>
          <th class="second-cell">Quantity</th>
          <th class="price-cell">Price/ea.</th>
          <th class="total-cell">Total</th>
        </tr>
      </thead>
      <tbody>
  `;

  data?.ticket_buckets && data.ticket_buckets.forEach(bucket => {
    tableHTML += `
      <tr class="ticket_buckets">
        <td class="item--info first-cell">
          <div>
            <div>${bucket.name} ${typeof bucket?.quantity_remaining === 'number' && bucket.quantity_remaining <= 0 ? `<br>(SOLD OUT)` : ''}</div>
          </div>
        </td>
        <td class="second-cell">
          <div class="quantity">
            <button class="button--minus" type="button" onclick="changeQuantity('${bucket.id}', -1, '${bucket.price}')">–</button>
            <input readonly class="input--quantity" type="number" id="quantity-${bucket.id}" value="0" min="0" max="${bucket.quantity_remaining !== 0 ? bucket.quantity_remaining : '0'}">
            <button class="button--plus" type="button" onclick="changeQuantity('${bucket.id}', 1, '${bucket.price}')">+</button>
            
          </div>
        </td>
        <td class="price-cell" id="price-${(bucket.id)}">${currencyFormatter(bucket.price / 100)}</td>
        <td class="subtotal subtotal-cell" id="subtotal-${bucket.id}">0,00 €</td>
      </tr>
    `;

    if (bucket?.variants && bucket.variants.length > 0) {
      bucket.variants.forEach(variant => {
        tableHTML += `
          <tr class="ticket_buckets">
            <td class="item--info first-cell">
              <div>
                <div>${variant.name} ${typeof bucket?.quantity_remaining === 'number' && bucket.quantity_remaining <= 0 ? `<br>(SOLD OUT)` : ''}</div>
              </div>
            </td>
            <td class="second-cell">
              <div class="quantity">
                <button class="button--minus" type="button" onclick="changeQuantity('${variant.id}', -1, '${variant.price}')">–</button>
                <input readonly class="input--quantity" type="number" id="quantity-${variant.id}" value="0" min="0" max="${bucket.quantity_remaining !== 0 ? bucket.quantity_remaining : '0'}">
                <button class="button--plus" type="button" onclick="changeQuantity('${variant.id}', 1, '${variant.price}')">+</button>
              </div>
            </td>
            <td class="price-cell" id="price-${(variant.id)}">${currencyFormatter(variant.price / 100)}</td>
            <td class="subtotal subtotal-cell" id="subtotal-${variant.id}">0,00 €</td>
          </tr>
        `;
      });
    }
  });
// const donateRow = donateInlineOrderPrompt()
//   if(donateRow) {
//     tableHTML += `
//      <tr class="ticket_buckets" id="donate__inline__order">
//           ${donateRow.donateFirstCell}
//           ${donateRow.donateSelectHtml}
//        <td class="total total-cell donation--total--cell">
//           <input class="custom__donation" type="text" id="custom__donation" placeholder="0,00 €" />
//        </td>
//      </tr>
//      `;
//   }
  tableHTML += `
     <tr class="ticket_buckets">
        <td class="item--info first-cell">&nbsp;</td>
        <td class="second-cell">&nbsp;</td>
        <td class="price-cell">&nbsp;</td>
        <td class="total total-cell" id="grand-total">0,00 €</td>
     </tr>
     `;

  tableHTML += `
          </tbody>
        </table>
      `;
  eventDetails.style.display= 'block'
  eventTable.innerHTML = tableHTML;
}